module.exports = __webpack_public_path__ + "img/bookit_logo.be5f3b85.png";